/* eslint-disable complexity */
import {
  SET_CONTENT,
  SET_CONTENT_ERROR,
  SET_FIRST_NAME,
  SET_OFFERED_FREE_TRIAL,
  SET_INCLUDE_FREE_TRIALS,
} from "../../actions/PremierPageFrame";

const initialState = {
  content: null,
};

const PremierPageFrame = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTENT: {
      return Object.assign({}, state, {
        content: action.content,
        errorMessage: undefined,
      });
    }
    case SET_CONTENT_ERROR: {
      return Object.assign({}, state, {
        errorMessage: action.errorMessage,
      });
    }
    case SET_INCLUDE_FREE_TRIALS: {
      return Object.assign({}, state, {
        includeFreeTrials: action.includeFreeTrials,
      });
    }
    case SET_OFFERED_FREE_TRIAL: {
      return Object.assign({}, state, {
        offeredFreeTrial: action.offeredFreeTrial,
      });
    }
    case SET_FIRST_NAME: {
      return Object.assign({}, state, {
        firstName: action.firstName,
      });
    }
    default: {
      return state;
    }
  }
};

export default PremierPageFrame;
